import { AUTH_SERVICE } from '@common/services/auth/auth.service.interface';
import { useMutation } from '@tanstack/react-query';
import { container } from 'tsyringe';

export default function useInitializeAuthMutation() {
  // #region Mutation
  const { isLoading, isSuccess, mutate } = useMutation({
    mutationFn: container.resolve(AUTH_SERVICE).initialize,
  });
  // #endregion

  return { isLoading, isSuccess, mutate };
}
